import React, { FC, memo } from "react";
import { ISvG } from "~/types/SvGTypes";

const Icon: FC<ISvG> = ({ fill = "#FFF" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19.25"
      height="22"
      viewBox="0 0 19.25 22"
    >
      <g id="txt" transform="translate(-565 -294)">
        <g id="file-extension" transform="translate(565 294)">
          <path
            id="Контур_725"
            data-name="Контур 725"
            d="M20.7,0H32.387l6.192,6.168V20.625A1.375,1.375,0,0,1,37.2,22H20.7a1.375,1.375,0,0,1-1.375-1.375V1.375A1.375,1.375,0,0,1,20.7,0Z"
            transform="translate(-19.329)"
            fill="#49a0e5"
          />
          <path
            id="Контур_726"
            data-name="Контур 726"
            d="M209.125,6.367h-4.793a1.375,1.375,0,0,1-1.375-1.375V.193Z"
            transform="translate(-189.894 -0.179)"
            fill="#125589"
          />
        </g>
        <path
          id="Контур_819"
          data-name="Контур 819"
          d="M3.449-3.521h-1.2V-.266H1.284V-3.521H.105v-.745H3.449ZM5.4-2.936l.654-1.33h1.1L6.041-2.282,7.189-.266H6.077L5.4-1.62,4.73-.266H3.621L4.766-2.282,3.651-4.266h1.1Zm5.3-.585H9.5V-.266H8.534V-3.521H7.355v-.745H10.7Z"
          transform="translate(568.899 309)"
          fill="#fff"
        />
      </g>
    </svg>
  );
};

export default memo(Icon);
